var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdvicesCategoryModule',{attrs:{"module-content":_vm.content,"page-articles":_vm.pageArticles,"total-page-size":_vm.totalPageSize,"current-page-index":_vm.currentPageIndex,"data-luko-tracking":"Page-Advice_slug"}})}
var staticRenderFns = []

export { render, staticRenderFns }